// extracted by mini-css-extract-plugin
export default {"root":"_3wS3e","theme-based":"_2YqwF","themeBased":"_2YqwF","content":"_1m2I5"};